const getCardResponse = (rawData: any) => {
  const result = rawData?.data?.data
  const transformedData: ResponseType = result?.map((contributionTags: any) => {
    const { id, name, count } = contributionTags || {}
    return {
      id,
      name,
      count,
    }
  })

  return {
    data: transformedData,
    info: rawData?.data?.meta?.info,
  }
}

const contributionTagsFormattedResponses = {
  getCardResponse,
}

export default contributionTagsFormattedResponses
